// assets
import {
  AppstoreOutlined,
  UserOutlined,
  ShoppingCartOutlined,
  CodeSandboxOutlined,
  PictureOutlined
} from '@ant-design/icons';

import { DashboardOutlined } from '@mui/icons-material';
import SellOutlinedIcon from '@mui/icons-material/SellOutlined';

// icons
const icons = {
  DashboardOutlined,
  AppstoreOutlined,
  UserOutlined,
  ShoppingCartOutlined,
  CodeSandboxOutlined,
  SellOutlinedIcon,
  PictureOutlined
};

// ==============================|| MENU ITEMS - GROCERY ||============================== //

const grocery = {
  id: 'group-grocery',
  title: 'MAIN',
  type: 'group',
  children: [
    {
      id: 'dashboard',
      title: 'Dashboard',
      type: 'item',
      url: '/dashboard',
      icon: icons.DashboardOutlined,
      breadcrumbs: false
    },
    {
      id: 'categories',
      title: 'Categories',
      type: 'item',
      url: '/categories',
      icon: icons.AppstoreOutlined,
      breadcrumbs: false
    },
    {
      id: 'products',
      title: 'Products',
      type: 'item',
      url: '/products',
      icon: icons.CodeSandboxOutlined,
      breadcrumbs: false
    },
    {
      id: 'customers',
      title: 'Customers',
      type: 'item',
      url: '/customers',
      icon: icons.UserOutlined,
      breadcrumbs: false
    },
    {
      id: 'orders',
      title: 'Orders',
      type: 'item',
      url: '/orders',
      icon: icons.ShoppingCartOutlined,
      breadcrumbs: false
    },
    {
      id: 'daily-update',
      title: 'Update prices',
      type: 'item',
      url: '/daily-update',
      icon: icons.SellOutlinedIcon,
      breadcrumbs: false
    },

  ]
};

export default grocery;




